import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContainerBase } from '../../../core/base/container-base';
import { Observable } from 'rxjs';
import { ApiOrder } from '../../../cart/models/cart-models';
import { Address } from '../../../core/models/address';
import { select, Store } from '@ngrx/store';
import * as fromCheckout from '../../reducers';
import * as fromCart from '../../../cart/reducers';
import * as fromBase from '../../../base/reducers';
import { takeUntil } from 'rxjs/operators';
import * as fromAuth from '../../../auth/reducers';
import * as checkout from '../../actions/checkout';
import { PageRoutingService } from '../../../core/services/page-routing.service';
import { Setting } from '../../../core/models/setting';

@Component({
  selector: 'app-checkout-second-step-container',
  templateUrl: './template.html'
})

export class CheckoutSecondStepContainer extends ContainerBase implements OnInit, OnDestroy {
  cartOrder$: Observable<ApiOrder>
  addresses$: Observable<Address[]>
  checkoutPageSettings$: Observable<Setting>

  committing$: Observable<boolean>
  commitError$: Observable<any>

  constructor(
    private store: Store<fromCheckout.State>,
    private pageRoutingSvc: PageRoutingService
  ) {
    super()
    this.pageRoutingSvc.breadcrumbsStatus = false

    this.cartOrder$ = store
      .pipe(
        select(fromCart.getOrder),
        takeUntil(this.destroyed$)
      )
    this.addresses$ = store
      .pipe(
        select(fromAuth.getAddresses),
        takeUntil(this.destroyed$)
      )

    this.checkoutPageSettings$ = store
      .pipe(
        select(fromBase.getCheckoutPageSettings),
        takeUntil(this.destroyed$)
      )

    this.committing$ = store
      .pipe(
        select(fromCheckout.isCreating),
        takeUntil(this.destroyed$)
      )
    this.commitError$ = store
      .pipe(
        select(fromCheckout.getError),
        takeUntil(this.destroyed$)
      )
  }

  ngOnInit() {
    this.store.dispatch(new checkout.ClearError())
  }

  ngOnDestroy() {
    this.pageRoutingSvc.breadcrumbsStatus = true
  }

  detailsChanged(order: ApiOrder) {
    this.store.dispatch(new checkout.Set(order))
  }

  createOrder(order: ApiOrder) {
    this.store.dispatch(new checkout.Submit(order))
  }
}
